export default {
  CAR: 'car',
  TRUCK: 'truck',
};
